// Pure query-param builder for the dynamic-price evaluation endpoint
// (`products/:id/dynamic-price/evaluate-price-rules`): each context entity is sent
// as `<key>Id`, plus an optional quantity, raw boat dimensions (for a manual boat
// with no id) and the duration/traveler inputs the rule engine multiplies factors
// by (VestingPeriod.Days/Overnights, Travelers.Quantity — both legacy + v2 groups).
// Side-effect free (no HttpParams / Angular) → unit testable; the api service just
// builds HttpParams from the returned pairs.
export function buildDynamicPriceRuleParams(
    entities: Record<string, { id?: number } | null | undefined>,
    quantity: number,
    boatDimensions?: { width: number; length: number },
    durations?: { days?: number; overnights?: number; travelers?: number },
): Record<string, string> {
    const params: Record<string, string> = {};
    for (const key of Object.keys(entities)) {
        const id = entities[key]?.id;
        if (id != null) {
            params[`${key}Id`] = String(id);
        }
    }
    if (quantity) {
        params['quantity'] = String(quantity);
    }
    if (boatDimensions) {
        params['boatLength'] = String(boatDimensions.length);
        params['boatWidth'] = String(boatDimensions.width);
    }
    // Only sent when > 0 — the engine gates duration/traveler factors on `> 0` and
    // defaults absent params to -1 (factor skipped), so omitting them is correct.
    if (durations) {
        if (durations.days != null && durations.days > 0) {
            params['days'] = String(durations.days);
        }
        if (durations.overnights != null && durations.overnights > 0) {
            params['overnights'] = String(durations.overnights);
        }
        if (durations.travelers != null && durations.travelers > 0) {
            params['travelers'] = String(durations.travelers);
        }
    }
    return params;
}
